export default (total, delay = 5000) => ({
  index: 0,
  total,
  timer: null,

  init() {
    this.start()
  },
  start() {
    clearInterval(this.timer)
    if (this.total > 1) {
      this.timer = setInterval(() => { this.index = (this.index + 1) % this.total }, delay)
    }
  },
  prev() {
    this.index = (this.index + this.total - 1) % this.total
    this.start()
  },
  next() {
    this.index = (this.index + 1) % this.total
    this.start()
  }
})
